import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";
import { ToastService } from "../toast/toast.service";
// import { toast } from 'ngx-sonner';

function convertObjectToString(obj: Record<string, string>) {
  const result = [];
  // Traverse the object and concatenate the messages
  for (const [key, value] of Object.entries(obj)) {
    result.push(`${key}: ${value}`);
  }
  return result.join(", ");
}

function checkForErrorMessage(err: any, originalMessage?: string): string {
  let message = "";

  if (err instanceof HttpErrorResponse) {
    // Check if the error has the expected structure
    if (err.error && (err.error.message || err.error.Message)) {
      message = err.error.message || err.error.Message;
    } else if (typeof err.error === "string") {
      message = err.error;
    }
  }

  // If no message was found, use the original message
  return message.length
    ? message
    : originalMessage || "An unknown error occurred.";
}

export const errorsInterceptor: HttpInterceptorFn = (req, next) => {
  const _router = inject(Router);
  const toastService = inject(ToastService);
  
  // Strip custom UI flags to avoid CORS issues
  let skipErrorToast = false;
  if (req.headers.has('X-Skip-Error-Toast')) {
    skipErrorToast = true;
    req = req.clone({ headers: req.headers.delete('X-Skip-Error-Toast') });
  }

  return next(req).pipe(
    catchError((err) => {
      // Check if this request explicitly wants to skip error modals
      if (skipErrorToast) {
        return throwError(() => err);
      }

      let errorMessage = "Error Occured";
      const errorStatus = err.status as number;

      if (errorStatus >= 400 && errorStatus < 500) {
        switch (errorStatus) {
          case 0: // No Internet Connection or Network Error
            errorMessage =
              "No internet connection. Please check your network and try again.";
            toastService.addToast({
              type: "error",
              message: `
                <h2>Network Error 😭😭😭😭😭😭😭</h2>
                <p>${errorMessage}</p>
              `
            });
            break;
          case 401: // unauthorized
            errorMessage = checkForErrorMessage(
              err,
              "You are unauthorized to continue, login again or report"
            );
            toastService.addToast({
              type: "error",
              message: `
                <h2>Session-expired 🤪</h2>
                <p>${errorMessage}</p>
              `
            });
            // Only redirect to login if this is NOT a background/act-as-customer request
            if (!req.url.includes('act-as-customer')) {
              _router.navigateByUrl("/login");
            }
            break;
          case 502: // other 4xx errors
            errorMessage = checkForErrorMessage(err, "Bad request");
            toastService.addToast({
              type: "error",
              message: `
                <h2>Bad request</h2>
                <p>${errorMessage}</p>
              `
            });
            break;
          case 406: // other 4xx errors
            errorMessage = checkForErrorMessage(err);
            toastService.addToast({
              type: "error",
              message: `
                  <h2>Bad request 🤣</h2>
                  <p>${errorMessage}</p>
                `
            });
            _router.navigateByUrl("/login");
            break;
          case 428: // 2FA flow condition — component handles routing, no toast needed
            break;
          default: // other 4xx errors
            errorMessage = checkForErrorMessage(err);
            toastService.addToast({
              type: "error",
              message: `<p>${errorMessage} ☹️</p>`
            });
            break;
        }
      }

      // backend errors
      if (errorStatus >= 500) {
        errorMessage = "Something went wrong, please try again or report";
        toastService.addToast({
          type: "error",
          message: `
				<h2>Backend error</h2>
				<p>${errorMessage}</p>
				`
        });
      }

      return throwError(() => err);
    })
  );
};
